let locationBasename;

/**
 * will be used to fetch current lang which we are using as a basename
 * @param basename
 */
export const setBaseName = basename => {
    locationBasename = basename;
};

export const getBaseName = () => locationBasename;
